"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Preview = require("./Preview");
Object.keys(_Preview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Preview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Preview[key];
    }
  });
});